import React, { useState } from "react";
import { signInWithGoogle } from "./firebaseUtils";

const Login = ({ onSuccess }) => {
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
    try {
        setLoading(true);
        const user = await signInWithGoogle();
        if (onSuccess) onSuccess(user);
    } finally {
        setLoading(false);
    }
    };

    return (
    <button
        className="homePrimaryButton"
        onClick={handleLogin}
        disabled={loading}
    >
        {loading ? "Signing in..." : "Sign In With Google"}
    </button>
    );
};

export default Login;
